var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showType === 'select')?_c('base-select',{attrs:{"value":_vm.value,"options":_vm.options,"select-props":{
    allowClear: true,
    loading: _vm.loading,
    placeholder: _vm.$t('common.tips.select', ['IP']),
  }},on:{"change":_vm.change}}):_c('a-input',{attrs:{"value":_vm.value},on:{"change":_vm.ipChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }